module.exports = __webpack_public_path__ + "img/builder-27.7b0260bf.jpg";